<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Agents</h5>
                </div>
                <vs-row>
                    <vs-col>
                        <h2>Agent connectés en temps réél: {{ count }}</h2>
                    </vs-col>
                </vs-row>
            </vs-card>
        </div>

        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Requêtes à temps réel par période</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-1/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-3/4 px-2">
                            <span>Liste des agents</span>
                            <v-select v-model="agent" class="w-full" 
                                label="name"
                                placeholder="Sélectionner un agent"
                                :reduce="user => user.id"
                                :options="users">
                                <template v-slot:option="option">
                                    {{ option.name +' '+option.first_name }}
                                </template>
                            </v-select>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === '' && agent == ''" @click="makeSearchRequest()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Recherche
                            </vs-button>
                        </div>
                    </div>
                </vs-row><br><br>
                <div class="app-dashboard">
                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="primary"
                                    content-color="#fff">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{ total_assign }} </h2>
                                        <span>Total Assigné par agent</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold"> {{ total_new }} </h2>
                                        <span>Total Nouveau par agent</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="success" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 text-white"> {{ total_close }} </h2>
                                        <span>Total fermés par agent</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="danger" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{ dma_agent }} </h2>
                                        <span>DMA par agent</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>

        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>DMA par catégories de plaintes</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-1/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRangeCategories"
                                :ranges=false
                                @update="updateValuesCategories"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-3/4 px-2">
                            <span>Liste des catégories</span>
                            <v-select v-model="category" class="w-full" label="name"
                                placeholder="Sélectionner la catégorie"
                                :reduce="cat => cat.id"
                                :options="categories">
                            </v-select>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRangeCategories.startDate === '' && dateRangeCategories.endDate === '' && category === ''" @click="makeSearchCategory()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Recherche
                            </vs-button>
                        </div>
                    </div>
                </vs-row><br><br>
                <div class="app-dashboard">
                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="primary" content-color="#fff">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                        <div class="truncate">
                                            <h2 class="mb-1 font-bold text-white"> {{ dma_category }} </h2>
                                            <span>DMA</span>
                                        </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
export default {
    components: {DateRangePicker},
    data: () => ({
        opens: 'right',
        count: 0,
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        categories: [],
        category: '',
        agent: '',
        users: [],
        total_assign: 0,
        total_new: 0,
        total_close: 0,
        dma_agent: 0,
        dma_category: 0,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateRangeCategories: {
            startDate: "",
            endDate: "",
        }
    }),
    mounted(){
        this.getAgent()
        this.getCategory()
        window.socket = setInterval(() => {
            this.socket();
        }, 5000)
        //this.listen()
    },
    beforeRouteLeave(to, from, next) {
      if (window.socket) {
        clearTimeout(window.socket)
      }
      next()
    },
    methods:{
        /*
        listen() {
            Echo.join('counter')
                .here(users => this.count = users.length)
                .joining(user => this.count++)
                .leaving(user => this.count--);
        },
        */
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        updateValuesCategories(values) {
            this.dateRangeCategories.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRangeCategories.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },

        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
            return classes
        },

        getAgent(){
            this.$vs.loading()
            this.$http.get('/users?paginate=0&profile=3').then((response) => {
                this.users = response.data
                this.$vs.loading.close()
            }).catch((error) =>{
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },

        socket(){
            let par = Math.floor(Math.random() * 6) + 1
            this.$http.post('/cex/socket?whr_query='+par).then((response) => {
                this.count = response.data
            }).catch((error) =>{
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },
        

        getCategory(){
            //this.$vs.loading()
            this.$http.get('/categories-requests?paginate=0').then((response) => {
                this.categories = response.data
                //this.$vs.loading.close()
            }).catch((error) => {
                //this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },
        makeSearchRequest() {
            this.$vs.loading()
            this.$http.post('/cex/request-agent-period', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
                agent: this.agent
            }).then((response) => {
            let content = response.data
            this.total_assign = content['total_assign']
            this.total_new = content['total_new']
            this.total_close = content['total_close']
            this.dma_agent = content['dma_agent']
            this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },

        makeSearchCategory() {
            this.$vs.loading()
            this.$http.post('/cex/request-dma-categories', {
                date_debut: this.dateRangeCategories.startDate,
                date_fin: this.dateRangeCategories.endDate,
                category: this.category
            }).then((response) => {
            this.dma_category = response.data
            this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        }
    }
}
</script>